import { Reducer } from 'react';
import {
  EFiltersActions,
  FilterActions,
  FilterState
} from '../types/filters.type';

export const filterReducer: Reducer<FilterState, FilterActions> = (
  state,
  action
) => {
  switch (action.type) {
    case EFiltersActions.ADD_CATEGORY: {
      return {
        ...state,
        filters: [...state.filters, action.payload]
      };
    }
    case EFiltersActions.REMOVE_CATEGORY: {
      return {
        ...state,
        filters: state.filters.filter((f) => f.id !== action.payload)
      };
    }
    case EFiltersActions.CLEAR_FILTERS: {
      return {
        code: 'gerdau',
        filters: [],
        search: '',
        sort: 'R'
      };
    }
    case EFiltersActions.ADD_SEARCH: {
      return {
        ...state,
        search: action.payload
      };
    }
    case EFiltersActions.REMOVE_SEARCH: {
      return {
        ...state,
        search: ''
      };
    }
    case EFiltersActions.SET_SORT: {
      return {
        ...state,
        sort: action.payload
      };
    }
    case EFiltersActions.SET_MATERIAL_CODE: {
      return {
        ...state,
        code: action.payload
      };
    }

    default:
      throw new Error('Filter Action not implemented');
  }
};
